import {
  Badge,
  Button,
  Card,
  Carousel,
  Col,
  Divider,
  Image,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
  Typography,
} from "../../../common/utils/antd-imports/AntdImports";
import Metrics from "../../../../assests/metrics-icon.svg";
import Product from "../../../../assests/products-14X48.svg";
import Billboard from "../../../../assests/Billboard-icon.svg";
import { ReactComponent as NotifyIcon } from "../../../../assests/notify-icon.svg";
import React, { useEffect, useState, useRef } from "react";
import {
  formatDateWithTimestamp,
  formatToUSCurrency,
  handleCopy,
} from "../../../common/utils/Utils";
import ChatBotSparkles from "../../../../assests/chatbot-sparklesIcon.svg";
import { CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { API_BASE_URL_IMAGE } from "../../../../services/common";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addBreadcrumb } from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import Modal from "antd/es/modal/Modal";
import NotifyModel from "../../../modal/notify-model/NotifyModel";
import LoginAlert from "../../../modal/login-alert/LoginAlert";
import AdPlacement from "../../../../features/Ads/adPlacement/adPlacement";
import { useMediaQuery } from "react-responsive";
import { CopyOutlined } from "@ant-design/icons";
import EmptyViewCard from "../../../common/empty-view-card/EmptyViewCard";
import { getPricePredictionOfProducts } from "../../../../store/thunks/common-thunks/commonThunk";
import Arrow3 from "../../../../assests/Arrow 3.svg";
import dayjs from "dayjs";
const Text = Typography;
const ProductGridCard = ({ currentPageData, recommendedProducts }) => {
  const [products, setProducts] = useState([]);
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const isMobile = useMediaQuery({
    minWidth: 768,
    maxWidth: 1024,
  });
  const { predictionLoader, prices } = useSelector((state) => state.products);
  const previousPathFromStore = useSelector(
    (state) => state.route.previousPath,
  );
  const stablePreviousPath = useRef(previousPathFromStore);
  // For the opening the view-button-page for the price-details
  const [isCampaignsPage, setIsCampaignsPage] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const [notify, setNotify] = useState(false);
  const [predictedPrice, setPredictedPrice] = useState([]);
  const [productId, setProductId] = useState("");
  const getPredictedPrice = (priceValue) => {
    if (!priceValue) return "";
    let modifiedNumber = priceValue.split("$");
    return Number(modifiedNumber[1]).toFixed(2);
  };
  const formatSize = (value) => {
    if (!value) return "";
    return value
      .replace(" feet", "'")
      .replace(/\s*line\s*inches/i, '"')
      .replace(" pixels", " px");
  };
  const safeIncludes = (value, searchValue) => {
    if (Array.isArray(value)) {
      return value?.some((item) => String(item ?? "")?.includes(searchValue));
    }
    return String(value ?? "").includes(searchValue);
  };
  useEffect(() => {
    if (Array.isArray(recommendedProducts)) {
      if (recommendedProducts.length > 0) {
        setProducts(
          recommendedProducts.map((product) => ({
            ...product,
            rateCard:
              product?.rateCard === "0"
                ? "Estimated Market Value"
                : product?.rateCard,
          })),
        );
      } else {
        setProducts([]);
      }
      return;
    }

    if (Array.isArray(currentPageData)) {
      if (currentPageData.length > 0) {
        setProducts(
          currentPageData?.map((item) => {
            const product = item?.product_details?.[0];
            return {
              ...product,
              rateCard:
                Number(product?.rateCard) === 0
                  ? "Estimated Market Value"
                  : product?.rateCard,
            };
          }),
        );
      } else {
        setProducts([]);
      }
    }
  }, [currentPageData, recommendedProducts]);

  useEffect(() => {
    if (
      stablePreviousPath?.current?.includes("/mycampaigns") ||
      stablePreviousPath?.current?.includes("campaigndetails")
    ) {
      setIsCampaignsPage(true);
    } else {
      setIsCampaignsPage(false);
    }
  }, [stablePreviousPath, previousPathFromStore]);
  const showAIPrice = (productId) => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      // passDataToParent(true);
      setPredictedPrice([{ productuniqueId: productId, rateCard: 0 }]);
      setProductId(productId);
      dispatch(getPricePredictionOfProducts({ product_id: productId }));
    }
  };
  const estimatedPriceTooltip = () => {
    return "This is an estimated market price generated by AI to guide you. The actual seller's price may differ.";
  };
  const getDateValues = (dateField) => {
    if (Array.isArray(dateField)) {
      return dateField;
    }
    return dateField ? [dateField] : [];
  };
  // Handling the navigation of each product
  const handleProductDetails = (product) => {
    if (isLoggedIn) {
      navigate(`/buyer/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/buyer/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
      setSelectedProduct(product);
    } else {
      navigate(`/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
    }
  };
  // Showing the product specs dynamically
  {
    products?.map((product, index) => {
      const specItems = [
        {
          key: "dimensions",
          tooltip: "Dimensions",
          icon: Product,
          value:
            product?.type?.toLowerCase() === "media"
              ? product?.length || "N/A"
              : product?.width && product?.height
                ? `${formatSize(product.width)} X ${formatSize(product.height)}`
                : "N/A",
        },
        {
          key: "impressions",
          tooltip: "Impressions",
          icon: Metrics,
          value: Number.isFinite(Number(product?.secondImpression))
            ? `${Number(product.secondImpression).toLocaleString()}+ `
            : "N/A",
        },
        {
          key: "type",
          tooltip: "Product Type",
          icon: Billboard,
          value: product?.type || "N/A",
        },
      ];

      return (
        <Row key={product?.id || index} className="grid-specification-layout">
          {specItems?.map((item, i) => (
            <React.Fragment key={item?.key}>
              <Col className="spec-col">
                <Tooltip title={item?.tooltip}>
                  <Row className="spec-icon-row">
                    <Image src={item?.icon} preview={false} />
                  </Row>

                  <div className="product-type spec-text-space">
                    {item?.value}
                  </div>
                </Tooltip>
              </Col>

              {i !== specItems.length - 1 && (
                <Divider type="vertical" className="spec-divider" />
              )}
            </React.Fragment>
          ))}
        </Row>
      );
    });
  }
  const getTableColumns = (product) => [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const getTableData = (product) => {
    if (!product) return [];

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = product?.unitQty || [];

    return fromDates.map((from, index) => ({
      key: index,
      startDate: dayjs(Number(from?.$date?.$numberLong)).format("MMM DD, YYYY"),
      endDate: dayjs(Number(toDates?.[index]?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      ),
      quantity: product?.type === "Digital" ? (quantities[index] ?? "-") : "-",
    }));
  };
  return (
    <>
      <div>
        {products?.length > 0 ? (
          <Row gutter={[24, 24]}>
            {products?.map((product, index) => {
              const fromDates = getDateValues(product?.from_date);
              const toDates = getDateValues(product?.to_date);
              const minFromTimestamp = Math.min(
                ...fromDates.map((item) => Number(item?.$date?.$numberLong)),
              );
              const maxToTimestamp = Math.max(
                ...toDates.map((item) => Number(item?.$date?.$numberLong)),
              );
              const firstFromDate =
                fromDates.length > 0
                  ? formatDateWithTimestamp(minFromTimestamp)
                  : "N/A";
              const firstToDate =
                toDates.length > 0
                  ? formatDateWithTimestamp(maxToTimestamp)
                  : "N/A";
              const slotsLength = Math.max(fromDates?.length, toDates?.length);
              const popoverContent = (
                <div className="slots-popover">
                  <div
                    className="product-title"
                    style={{ marginBottom: "10px" }}
                  >
                    Available Slots
                  </div>
                  <Table
                    columns={getTableColumns(product)}
                    dataSource={getTableData(product)}
                    pagination={false}
                    rowKey="key"
                    size="small"
                    className="billboard-table"
                  />
                </div>
              );
              return (
                <React.Fragment key={product?.id}>
                  {index === 5 && (
                    <Col
                      xl={8}
                      lg={8}
                      md={12}
                      sm={24}
                      className="add-grid-views"
                    >
                      <Card
                        hoverable
                        className="product-card-desk grid-view-card "
                      >
                        <AdPlacement
                          type="products"
                          position="grid view (6th tile)"
                          className="grid-sixth-tile margin-styles grid-side"
                        />
                      </Card>
                    </Col>
                  )}
                  <Col key={product?.id} xl={8} lg={8} md={12} sm={24}>
                    <Card
                      hoverable
                      className="product-card-desk grid-view"
                      onClick={() => handleProductDetails(product)}
                    >
                      <div
                        className="product-image-wrapper"
                        onClick={(e) => {
                          // restricting  the navigation using arrows and dots
                          if (
                            e.target.closest(".slick-prev") ||
                            e.target.closest(".slick-next") ||
                            e.target.closest(".slick-dots")
                          ) {
                            e.stopPropagation();
                          }
                        }}
                      >
                        {Array.isArray(product?.image) &&
                        product?.image?.length > 1 ? (
                          <Carousel arrows infinite>
                            {product?.image?.map((img, index) => (
                              <div key={index} className="carousel-image-slide">
                                <img
                                  className="product-grid-images product-grid-stretch"
                                  src={
                                    img
                                      ? product?.insert_type ===
                                        "Bulk_Apparatix_api"
                                        ? img
                                        : `${API_BASE_URL_IMAGE}${img}`
                                      : ""
                                  }
                                  alt={`product-${index}`}
                                />
                              </div>
                            ))}
                          </Carousel>
                        ) : (
                          <img
                            className="product-grid-images "
                            src={
                              product?.image?.[0]
                                ? product?.insert_type === "Bulk_Apparatix_api"
                                  ? product.image[0]
                                  : `${API_BASE_URL_IMAGE}${product.image[0]}`
                                : ""
                            }
                            alt="product"
                          />
                        )}
                      </div>

                      <div className="grid-product-title-available-state">
                        <div
                          style={{
                            width:
                              new Date(
                                Number(product?.to_date?.$date?.$numberLong),
                              ) <= new Date() && !isMobile
                                ? "65%"
                                : "100%",
                          }}
                        >
                          <Row className="product-copy-text-field">
                            {" "}
                            <Text className="product-id grid-product-site-number">
                              {product?.siteNo}
                            </Text>{" "}
                            <CopyOutlined
                              onClick={(e) => {
                                e.stopPropagation(); // prevent tooltip close
                                handleCopy(product?.siteNo);
                              }}
                              className="copy-icon"
                            />{" "}
                          </Row>
                          <div className="product-copy-text-field product-copy-text-field-full">
                            <Tooltip
                              styles={{
                                body: {
                                  color: "#fff",
                                  backgroundColor: "#000",
                                },
                              }}
                              title={
                                <pre className="tooltip-product-card">
                                  {product?.title}
                                </pre>
                              }
                            >
                              <Text
                                strong
                                className="product-title-grid truncate"
                              >
                                {product?.title}
                              </Text>
                              <CopyOutlined
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent tooltip close
                                  handleCopy(product?.title);
                                }}
                                className="copy-icon"
                              />
                            </Tooltip>
                          </div>
                        </div>
                        {new Date(
                          Number(product?.to_date?.$date?.$numberLong),
                        ) <= new Date() && (
                          <div className="grid-not-available-col">
                            <Row className="grid-not-available-container">
                              <Text className="grid-not-available-text">
                                Not Available
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>

                      <div className="product-card-format-dates-div grid-view-dates-container">
                        <Row style={{ marginBottom: "5px", width: "100%" }}>
                          <Text className="truncate common-text-364153-14">
                            City : {product?.city_name}
                          </Text>
                        </Row>

                        <Text className="available-txt-grid">Available</Text>
                        <Space size={4}>
                          <span className="common-text-364153-14-500 product-availability ">
                            {firstFromDate}
                          </span>
                          <div className="format-arrow">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="16"
                              viewBox="0 0 23 16"
                              fill="none"
                            >
                              <path
                                d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM8.74228e-08 9L22 9L22 7L-8.74228e-08 7L8.74228e-08 9Z"
                                fill="#D2042D"
                              />
                            </svg>
                          </div>
                          <span className="common-text-364153-14-500 product-availability ">
                            {firstToDate}
                          </span>
                        </Space>
                        {slotsLength > 1 && (
                          <Popover
                            placement="right"
                            trigger="click"
                            content={popoverContent}
                          >
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                              className="view-slots-link"
                            >
                              View Slots
                            </span>
                          </Popover>
                        )}
                      </div>
                      {!isMobile ? (
                        <Row className="grid-specification-layout">
                          <Col>
                            <Tooltip title="Dimensions">
                              <Row className="spec-icon-row">
                                <Image src={Product} preview={false} />
                              </Row>
                              <div className="product-size-text">
                                {product?.type?.toLowerCase() === "media"
                                  ? product?.length || "N/A"
                                  : product?.width && product?.height
                                    ? `${formatSize(product.width)} X ${formatSize(product.height)}`
                                    : "N/A"}
                              </div>
                            </Tooltip>
                          </Col>

                          <Divider
                            type="vertical"
                            className="product-card-divider-css height-styling"
                          />

                          <Col>
                            <Tooltip title="Impressions">
                              <Row className="spec-icon-row">
                                <Image src={Metrics} preview={false} />
                              </Row>

                              <div
                                className="product-type"
                                style={{ marginTop: "10px" }}
                              >
                                {Number.isFinite(
                                  Number(product?.secondImpression),
                                )
                                  ? `${Number(product.secondImpression).toLocaleString()}+ `
                                  : "N/A "}
                              </div>
                            </Tooltip>
                          </Col>

                          <Divider
                            type="vertical"
                            className="product-card-divider-css height-styling"
                          />

                          <Col>
                            <Tooltip title="Product Type">
                              <Row className="spec-icon-row">
                                <Image src={Billboard} preview={false} />
                              </Row>
                              <div
                                className="product-type"
                                style={{ marginTop: "10px" }}
                              >
                                {product?.type ? product?.type : "N/A"}
                              </div>
                            </Tooltip>
                          </Col>
                        </Row>
                      ) : (
                        <>
                          <Row className="grid-specification-layout">
                            <Col className="small-screen-container">
                              <Tooltip title="Dimensions">
                                <Row className="spec-icon-row">
                                  <Image src={Product} preview={false} />
                                </Row>
                                <div className="product-size-text">
                                  {product?.type?.toLowerCase() === "media"
                                    ? product?.length || "N/A"
                                    : product?.width && product?.height
                                      ? `${formatSize(product.width)} X ${formatSize(product.height)}`
                                      : "N/A"}
                                </div>
                              </Tooltip>
                            </Col>

                            <Divider
                              type="vertical"
                              className="product-card-divider-css height-styling"
                            />

                            <Col className="small-screen-container">
                              <Tooltip title="Impressions">
                                <Row className="spec-icon-row">
                                  <Image src={Metrics} preview={false} />
                                </Row>

                                <div
                                  className="product-type"
                                  style={{ marginTop: "10px" }}
                                >
                                  {Number.isFinite(
                                    Number(product?.secondImpression),
                                  )
                                    ? `${Number(product.secondImpression).toLocaleString()}+ `
                                    : "N/A "}
                                </div>
                              </Tooltip>
                            </Col>
                          </Row>
                          <Row className="grid-specification-layout">
                            <Col className="small-screen-container">
                              <Tooltip title="Product Type">
                                <Row className="spec-icon-row">
                                  <Image src={Billboard} preview={false} />
                                </Row>
                                <div
                                  className="product-type"
                                  style={{ marginTop: "10px" }}
                                >
                                  {product?.type ? product?.type : "N/A"}
                                </div>
                              </Tooltip>
                            </Col>
                          </Row>
                        </>
                      )}
                      <Row className="grid-pricing-section">
                        {!safeIncludes(
                          product?.rateCard,
                          "Estimated Market Value",
                        ) ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Text strong className="price-text">
                              {formatToUSCurrency(
                                Number(product?.rateCard)?.toFixed(2),
                              )}
                            </Text>
                            {""}
                            <span
                              className="per-week"
                              style={{ marginBottom: "-10px" }}
                            >
                              {" "}
                              Per 4 Weeks
                            </span>
                          </div>
                        ) : (
                          <>
                            {showAIPrice && product?.id === productId ? (
                              <>
                                {predictionLoader ? (
                                  <div className="product-card-loader">
                                    <Spin size="small" />
                                  </div>
                                ) : (
                                  <Badge
                                    count={
                                      <span>
                                        <div>
                                          <span strong className="price-text">
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.estimated_price,
                                              ),
                                            )}
                                          </span>
                                          <span className="per-week">
                                            {" "}
                                            Per 4 Weeks
                                          </span>
                                        </div>
                                        <div className="range-section">
                                          <Image
                                            className="sparkles"
                                            src={ChatBotSparkles}
                                            preview={false}
                                          />
                                          <span className="default-color">
                                            {" "}
                                            Estimated Market Value
                                          </span>{" "}
                                          <Tooltip
                                            placement="top"
                                            title={estimatedPriceTooltip()}
                                          >
                                            <InfoCircleOutlined />
                                          </Tooltip>
                                          <div className="price-range">
                                            Range:{" "}
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.price_lower_limit,
                                              ),
                                            )}{" "}
                                            -{" "}
                                            {formatToUSCurrency(
                                              getPredictedPrice(
                                                prices?.predicted_price
                                                  ?.price_upper_limit,
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      </span>
                                    }
                                    color="#f5f5f5"
                                  ></Badge>
                                )}
                              </>
                            ) : (
                              <Text
                                strong
                                className="ai-price"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  showAIPrice(product?.id);
                                }}
                              >
                                Estimated Market Value
                              </Text>
                            )}
                          </>
                        )}

                        <Col>
                          {new Date(
                            Number(product?.to_date?.$date?.$numberLong),
                          ) <= new Date() && (
                            <div
                              className="notify-section grid-notify-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!isLoggedIn) {
                                  setLoginPopoverVisible(true);
                                  return;
                                }
                                setSelectedProduct(product);
                                setNotify(true);
                              }}
                            >
                              {" "}
                              <Button
                                type="link"
                                key={product?.id}
                                className="notify-me notify-me-grid-button"
                              >
                                <NotifyIcon style={{ color: "#d2042d" }} />
                                Notify me
                              </Button>{" "}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  {index === products?.length - 1 && (
                    <Row className="grid-bottom-add">
                      <div
                        style={{
                          width: "950px",
                          textAlign: "center",
                        }}
                      >
                        <AdPlacement
                          type="products"
                          position="bottom"
                          index={2}
                        />
                      </div>
                    </Row>
                  )}
                </React.Fragment>
              );
            })}
          </Row>
        ) : (
          <div className="grid-empty-view-card">
            <EmptyViewCard
              header={"Matches..."}
              text={
                "There are no products available for your selected criteria. Please update your filters to explore more options."
              }
            />
          </div>
        )}
      </div>
      <Modal
        open={notify}
        onCancel={() => setNotify(false)}
        closable={true}
        className="notify-modal"
        footer={false}
        centered
      >
        <NotifyModel
          openNotify={notify}
          setNotify={setNotify}
          product={selectedProduct}
        />
      </Modal>
      <LoginAlert
        loginPopoverVisible={loginPopoverVisible}
        setLoginPopoverVisible={setLoginPopoverVisible}
      />
    </>
  );
};
export default ProductGridCard;
